import React from 'react';

export const getDocOptionsSelectStreet = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => {
    const city = item.city || null;

    let option = item.name;

    if (city) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {city}
          </div>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.name}
          </div>
        </div>
      );
    }

    return {
      ...item,
      key: item.id,
      value: item.id || item.name,
      content: option || String(item.id),
      search: item.name || String(item.id),
      text: item.name || String(item.id),
    };
  });
};
